import {useMemo,useEffect,useState,useRef } from 'react'
import {useGetProcessFromInstanceQuery,usePublishProcessInstanceDataMutation,useLoadUserQuery,
		useCompleteProcessStateMutation,databaseViewApi,useAddCommentMutation,useLoadCommentsQuery,
		useGetLoginStatusQuery,useListInstanceFormsQuery,useListInstanceStateDataQuery,useGetMemberAccessQuery,
		useCreateProcessStateEntryMutation} from './redux/databaseView';
//import {useMemo,useEffect,useState,useRef } from 'react'
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { TextField} from '@mui/material';
import { Button} from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
//import {useLoadUserQuery,useAddUserMutation} from './redux/databaseView';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {useAddMemberAccessMutation} from './redux/databaseView'

export function AddMemberDialog(props) {
  const [selectedValue, setSelectedValue] = useState("");
  var emails=[];
  const { onClose,  open, type, onlyPublished } = props;
  const { data, error, isLoading }={data:[],error:null,isLoading:false};
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const userList=useLoadUserQuery();
  const [userData,setUserData]=useState([]);
  const [supervisor,setSupervisor]=useState(0);
  const [showUnassigned, setShowUnassigned]=useState(false);
  const [name,setName]=useState("");
  const [displayName,setDisplayName]=useState("");
  const [email,setEmail]=useState("");
  const [specialObject,setSpecialObject]=useState({});
  const [addMemberAccess]=useAddMemberAccessMutation();
 async function onSubmit()
	{
	var access=0;
	Object.keys(specialObject).forEach((x)=>{
//		console.log(access,x,invert[x].toString(16));
		if (specialObject[x])
			(access=access|(invert[x]?invert[x]:0));
		});
	if (supervisor!=0)
		{
		addMemberAccess({instance:props.instance,user:supervisor,access});
		}
//	console.log(access.toString(16));
//	await addUser({userInfo,areasObject,rolesObject});
	handleClose(name);
	}
  useEffect(()=>{
	if (!userList.isSuccess)
		return;
	//userData=userList.data.data;
	var data=[{id:0,name:"Not set"},...userList.data.data];
	setUserData(data);
//	console.log(data);
	},[userList]);
  function handleChange(e){
//	console.log(e.target.value);
	setSupervisor(e.target.value);
  }
  if (isLoading)
	return null;
  if (!error&&data.success)
	emails=data.data;

  const handleClose = async () => {
		await onClose(selectedValue);
//		setSelectedValue(null);
  };
  const invert={"Process Owner":0x200,"Process Initiator":0x100,
				"readAll data":0xf,"readGeneral access":0x7,"readTeam documents":0x3,"readOwn documents":0x1,
				"writeAll data":0xf0,"writeGeneral access":0x70,"writeTeam documents":0x30,"writeOwn documents":0x10
				};


  function updateObject(key,value)
	{
	var replaceObj={...specialObject}
	replaceObj[key]=value;
//	console.log(replaceObj);
	setSpecialObject(replaceObj);
	}
  const special=["Process Owner","Process Initiator"];
  const read=["All data","General access","Team documents"];
  var lastChecked=false;
//() => handleListItemClick(email.formid)
  return (
    <Dialog sx={{p:2,m:0}} onClose={handleClose} open={open}>
      <DialogTitle>Add member to process</DialogTitle>
	  <Paper sx={{ maxWidth:800,m:2,p:2,maxHeight:'50%',overflowY:'auto',overFlowX:'none'}}>
	  <Stack sx={{mt:1,mb:1}} direction="column" margin="dense" >
		<FormControl fullWidth>
          <FormLabel htmlFor="supervisor">Member Name</FormLabel>
		  <Select
			labelId="demo-simple-select-label"
			id="demo-simple-select"
			value={supervisor}
			onChange={handleChange}
		  >
		  {userData.map((x)=>{
			return (<MenuItem value={x.id}>{x.name}</MenuItem>)
			})
			}
		  </Select>
		</FormControl>
		<Stack direction="row" sx={{mt:2,flexWrap:"wrap" }} >
		<Stack direction="column" sx={{width:190}}>
		<FormLabel  htmlFor="supervisor">Special Access</FormLabel>
		<FormGroup sx={{width:200}} margin="dense">
			{special.map((x)=>{
			var disabled=false;
			var checked=specialObject[x]?true:false;
			return (<FormControlLabel key={x} margin="dense" control={<Checkbox  disabled={disabled} onChange={(evt)=>updateObject(x,evt.target.checked)} checked={checked}/>} label={x} />)
			})}
		</FormGroup>
		</Stack>
		<Stack direction="column" sx={{width:190}}>
		<FormLabel  htmlFor="supervisor">Write Access</FormLabel>
		<FormGroup sx={{width:200}} margin="dense">
			{read.map((x,idx)=>{
			var name="write"+x;
			var disabled=false;
			var checked=specialObject[name]?true:false;
			if (idx==0)
				lastChecked=false;
			if (lastChecked)
				{
				checked=true;
				disabled=true;
				}
			lastChecked=checked;
			return (<FormControlLabel key={x} margin="dense" control={<Checkbox  disabled={disabled} onChange={(evt)=>updateObject(name,evt.target.checked)} checked={checked}/>} label={x} />)
			})}
		</FormGroup>
		</Stack>
		<Stack direction="column" sx={{width:190}}>
		<FormLabel  htmlFor="supervisor">Read Access</FormLabel>
		<FormGroup sx={{width:200}} margin="dense">
			{read.map((x,idx)=>{
			var disabled=false;
			var checked=specialObject["read"+x]?true:false;
			if (idx==0)
				lastChecked=false;
			if (lastChecked)
				{
				checked=true;
				disabled=true;
				}
			lastChecked=checked;
//			console.log(checked);
			return (<FormControlLabel key={x} margin="dense" control={<Checkbox  disabled={disabled} onChange={(evt)=>updateObject("read"+x,evt.target.checked)} checked={checked}/>} label={x} />)
			})}
		</FormGroup>
		</Stack>
   	  </Stack>
	  </Stack> 
	  </Paper>
	  <Stack sx={{padding:2}} direction="row" spacing={2}>
		<Button onClick={onSubmit}  variant="contained">{"Add"}</Button>
		<Button onClick={()=>handleClose(null)} variant="contained">Cancel</Button>		
	  </Stack>
    </Dialog>
  );
}

function AccessToText(access)
	{
	if (access&0x200)
		return "Process owner";
	if (access&0x100)
		return "Process initiator";
	if (access==0)
		return "None";

/*
const readAssigned=1;
const readOwnTeam=2;
const readAccessAll=4;
const readAccessAllUnrestricted=8;
const readAny=readAssigned+readOwnTeam+readAccessAll+readAccessAllUnrestricted;
const writeAssigned=0x10;
const writeOwnTeam=0x20;
const writeAccessAll=0x40;
const writeAccessAllUnrestricted=0x80;
const writeAny=writeAssigned+writeOwnTeam+writeAccessAll+writeAccessAllUnrestricted;
const processInitiator=0x100;
const processOwner=0x200;

*/
	var write="";
	var read="";
	if (access&0x80)
		write="Write Any";
	else if (access&0x40)
		write="Write Non-Confidential";
	else if (access&0x20)
		write="Write Team";
	else 
		write="Write None";
		
	if (access&0x8)
		read="Read Any";
	else if (access&0x4)
		read="Read Non-Confidential";
	else if (access&0x2)
		read="Read Team";
	else 
		read="Read None";
	return write+" : "+read
	}
export function MemberBox({instance,userList})
	{
	var [activeMembers,setActiveMembers]=useState([]);
	const members=useGetMemberAccessQuery({instance});
	const [open,setOpen]=useState(false);
	function handleClose()
		{
		setOpen(false);
		}
	useEffect(()=>{
		if (members.isSuccess)
			{
//			console.log(members);
			setActiveMembers(members.data.data);
			}
	
		},[members.isSuccess,members]);
	return (<div>
			<AddMemberDialog instance={instance} open={open} onClose={handleClose}/>
			<div style={{maxHeight:200,overflowY:'auto',textAlign:'left'}}>
			{activeMembers.map((x,idx)=>{
				return <div key={x.id} style={{borderBottom: "1px solid orange"}}>{userList[x.id]?.name+" ("+AccessToText(x.access)+")"}</div>
				})
			}
			</div>
			<Button sx={{mt:2}} onClick={()=>{setOpen(true)}} variant="contained">Add Member</Button>		
			</div>)
				
			
	}
